import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AdminAnalytics } from 'src/domain/analytics';
import { OrganizationType } from 'src/domain/organization';
import { AnalyticsCard } from './AnalyticsCard';
import { Table } from 'src/components/Table';
import { messageTotal } from './MessageTrend';

export const OrganizationComparison = ({
    organizations,
}: {
    organizations: AdminAnalytics['organizations'];
}) => {
    const { t, i18n } = useTranslation();
    const number = (value: number) => value.toLocaleString(i18n.language);
    const typeLabel = (type?: OrganizationType) =>
        type
            ? t(
                  `admin.forms.createOrganization.${
                      type === OrganizationType.careHome
                          ? 'typeCareHome'
                          : 'typeNursingHome'
                  }`,
              )
            : t('admin.analytics.unknownType');

    return (
        <AnalyticsCard
            title={t('admin.analytics.byOrganization')}
            description={t('admin.analytics.deduplicationNote')}
        >
            <div className="overflow-x-auto">
                <Table
                    data={organizations}
                    emptyMessage={t('admin.analytics.empty')}
                    columns={[
                        {
                            header: t('admin.analytics.organization'),
                            sortKey: 'name',
                            sortValue: org => org.name,
                        },
                        { header: t('admin.analytics.homeType') },
                        {
                            header: t('admin.analytics.residents'),
                            sortKey: 'residents',
                            sortValue: org => org.people.residents,
                        },
                        {
                            header: t('admin.analytics.relatives'),
                            sortKey: 'relatives',
                            sortValue: org => org.people.relatives.total,
                        },
                        {
                            header: t('admin.analytics.fullTimeEmployees'),
                            sortKey: 'employees',
                            sortValue: org => org.people.employees.total,
                        },
                        {
                            header: t('admin.analytics.originalMessages'),
                            sortKey: 'messages',
                            sortValue: org => messageTotal(org.messages),
                        },
                    ]}
                    renderRow={org => (
                        <tr key={org.id}>
                            <td>
                                <Link
                                    className="underline"
                                    to={`/app/admin/organization/${org.id}`}
                                >
                                    {org.name}
                                </Link>
                            </td>
                            <td>{typeLabel(org.type)}</td>
                            <td>{number(org.people.residents)}</td>
                            <td>{number(org.people.relatives.total)}</td>
                            <td>{number(org.people.employees.total)}</td>
                            <td>{number(messageTotal(org.messages))}</td>
                        </tr>
                    )}
                />
            </div>
        </AnalyticsCard>
    );
};
